// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "b318774/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + chunkId + "." + {"345":"7c191e0040fbd7142231","500":"a3c7cb407159391d7e1a","538":"10a491ca235d8bcbfcef","937":"55c684a762e30b64b0f2","983":"2135910f3d152b94ffe6"}[chunkId] + ".js";
};